import React from 'react'
import { IoIosArrowForward } from 'react-icons/io'
import { Link, useLocation } from 'react-router-dom'

const Breadcrumb = () => {
    const location = useLocation()
    const pathnames = location.pathname.split('/').filter((x) => x)
    // const pathnames = [...new Set(location.pathname.split('/').filter((x) => x))]
    // const pathnames = location.pathname.split('/').filter((x, index, self) => x && self.indexOf(x) === index) // Remove duplicates

    // Remove the first two elements (index 0 and 1)
    const filteredPathnames = pathnames.slice(2)
    return (
        <nav className="text-base p-4 !border-b-[1px] flex flex-row items-center">
            <Link to="/GRC/help-center" className="text-[#555]">Help Center</Link>
            {filteredPathnames?.map((name, index) => {
                const routeTo = `/GRC/help-center/${filteredPathnames?.slice(0, index + 1).join('/')}`
                const isLast = index === filteredPathnames?.length - 1

                return (
                    <span key={name} className='hover:text-primary text-[#555] flex flex-row items-center'>
                        <IoIosArrowForward className='mx-2 w-6 h-6 text-primary' />
                        {isLast
                            ? (
                                <span className="text-primary font-bold capitalize"> {name?.replaceAll('-', ' ').replace(/\bgrc\b/gi, 'GRC')}</span>
                            )
                            : (
                                <Link to={routeTo} className="text-gray-500 capitalize ">
                                    {name?.replaceAll('-', ' ')}
                                </Link>
                            )}
                    </span>
                )
            })}
        </nav>
    )
}

export default Breadcrumb
